/* This file is autogenerated, see readme.md for instructions */
import StarSvgIcon from '@bloomreach/banana-theme/icons/star.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StarIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StarSvgIcon />
    </Icon>
  );
});

StarIcon.displayName = 'StarIcon';

export default StarIcon;
